import { Component, Input, OnInit } from "@angular/core";
import * as L from "leaflet";
import 'leaflet-draw';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';

@Component({
  selector: 'app-leaf-let',
  templateUrl: './leaf-let.component.html',
  styleUrls: ['./leaf-let.component.css']
})
export class LeafLetComponent implements OnInit {
	//map: Map;
  @Input() polygonArray;
  boundarArray = [];
   api_key = "wly6pnqvmbuioatp8an1zigi6n3h6mntxr5c4mxw";

	constructor() {}
	ngOnInit(): void {
    //console.log('polygonArray',this.polygonArray);
    this.polygonArray.forEach((boundary => {
      console.log('boundary',boundary);
      this.boundarArray.push(boundary[1]);
    }))
		const container = document.getElementById('map')
    var map = L.map(container).setView([-30.5595,22.9375], 13);
    L.tileLayer("https://api.maps.geoint.africa/v1/"+this.api_key+"/tile/{x}/{y}/{z}.png?settings=global-decarta_TT").addTo(map);

		  // L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
			//   attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
		  // }).addTo(map);
		  // FeatureGroup is to store editable layers
		 // const drawnItems = L.featureGroup().addTo(map);
		  // Initialise the FeatureGroup to store editable layers
var editableLayers = new L.FeatureGroup();
var downloadEditableLayers = new L.FeatureGroup();
map.addLayer(editableLayers);

var polyLayers = [];
// Add the layers to the drawnItems feature group
polyLayers = this.polygonArray;

let currentEditable = null;
let currentEditableArray = [];
for(let layers of polyLayers) {
  console.log("layer",layers);
  console.log(layers.feature);
 var layer = layers[0] ,

			feature = layer.feature = layer.feature || {};
	console.log("feature ::",feature);
	feature.type = feature.type || "Feature";
	feature.properties = layers[1]
	console.log("feature ::",feature);

    var props = feature.properties = feature.properties || {};
    // props.desc = null;
    // props.image = null;
	editableLayers.addLayer(layer);
	layer.on('click', function(e){
    console.log("edit click",e);
		//debugger;
		//e.target.editing.enable();
    	currentEditable = e.target;

		let isEditable = (downloadEditableLayers.getLayer(e.target._leaflet_id) == undefined);
		console.log("currentEditable",currentEditable,downloadEditableLayers.getLayer(e.target),(downloadEditableLayers.getLayer(e.target.editing) == undefined))
		if (downloadEditableLayers.getLayer(e.target._leaflet_id) != undefined){
			currentEditable.editing.disable();
			downloadEditableLayers.removeLayer(e.target);

		}
		console.log("after if currentEditable",currentEditable)
		console.log(downloadEditableLayers.getLayer(e.target._leaflet_id),(downloadEditableLayers.getLayer(e.target._leaflet_id) == undefined))
		if(isEditable){
    	// currentEditable = e.target;
		console.log("after if e target currentEditable",currentEditable)
	addPopup(currentEditable);



		e.target.editing.enable();
		downloadEditableLayers.addLayer(currentEditable);
		console.log("after if e target editing currentEditable",e.target.editing)
		console.log("after if e target currentEditable",currentEditable)
		}
	})
}
		  const drawControl = new L.Control.Draw({
       // position: "topright",
		 draw: {
			polygon: {
				allowIntersection: false, // Restricts shapes to simple polygons
				drawError: {
				  color: '#e1e100', // Color the shape will turn when intersects
				  message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
				},
				shapeOptions: {
				  color: '#97009c'
				}
			  },
		   polyline: false,
		   marker: false,
		   circlemarker: false,
		   rectangle:false
		 },
		 edit: {
			featureGroup: editableLayers,
		  },
	   });
	   //map.addControl(drawControl);



	   map.on("draw:created", function (e) {
		   console.log("created",e)
		var type = e['layerType'],
			layer = e['layer']
			,
			feature = layer.feature = layer.feature || {};

    feature.type = feature.type || "Feature";
	var props = feature.properties = feature.properties || {};
	props.Id = ''
	props.Name =''
	props.Descriptio = ''
	props.Region = ''
	props.Contract = ''
    // props.desc = null;
    // props.image = null;
		if (type === 'marker') {
			// Do marker specific actions
		}
		// Do whatever else you need to. (save to db; add to map etc)

		//map.addLayer(layer);

		editableLayers.addLayer(layer);
		addPopup(layer);
		var selectedFeature = null;
    layer.on('click', function(e){
			console.log("event click ",e.target)
			let isEditable = (downloadEditableLayers.getLayer(e.target._leaflet_id) == undefined);
			if(downloadEditableLayers.getLayer(e.target._leaflet_id) != undefined){
			   selectedFeature.editing.disable();
			   downloadEditableLayers.removeLayer(e.target);
			}

			if(isEditable){
          		selectedFeature = e.target;
				  e.target.editing.enable();
				  downloadEditableLayers.addLayer(selectedFeature);
			}
		})

		var data = editableLayers.toGeoJSON();
		//console.log('polygon data', data)
		L.geoJSON(data,{onEachFeature: function (feature, layer) {
			// layer.bindPopup(feature.properties.description);
			//console.log("feature",feature,layer)
		}})

	 });

	//  document.getElementById('export').onclick = function(e) {
	// 	// Extract GeoJson from featureGroup
	// 	var data = editableLayers.toGeoJSON();
	// 	var newData :any = downloadEditableLayers.toGeoJSON();

	// 	// Stringify the GeoJson
  //   var convertedData = 'text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(data));

  //   var sampledata = { "type": "FeatureCollection",
	// 							"features": [
	// 								{
	// 								"type": "Feature",
	// 								"geometry": { "type": "Polygon", "coordinates": [[102.0, 0.5], [102.0, 11.5],[103.0, 8.5]] },
	// 								"properties": { "name": "boundary","id":1,"description":"test description" }
	// 								},
	// 								{
	// 								"type": "Feature",
	// 								"geometry": { "type": "Polygon", "coordinates": [[10.0, 0.5], [12.0, 11.5],[13.0, 8.5]] },
	// 								"properties": { "name": "boundary1","id":2,"description":"test description1" }
	// 								}
	// 						]};
  //     console.log('export input sampledata',sampledata);


  //     var options = {
  //     folder: 'myshapes',
  //     types: {
  //       point: 'mypoints',
  //       polygon: 'mypolygons',
  //       line: 'mylines'
  //     }
  //   }


  //   //shpwrite.download(sampledata,options);

  //   setTimeout(() => {
	// 	if(newData.features.length>0){
	// 		shpwrite.download(newData,options);
	// 	}
	// 	else{
	// 		shpwrite.download(data,options);

	// 	}

  //     }, 3000);


	// 	// Create export
	// 	// document.getElementById('export').setAttribute('href', 'data:' + convertedData);
	// 	// document.getElementById('export').setAttribute('download','data.geojson');
	// }

	map.on('draw:edited', function (e) {
		console.log("edit e",e);


		downloadEditableLayers.clearLayers()
		console.log('map edited events trigger')
	});

	map.on('draw:deleted', function () {
		// Update db to save latest changes.
		console.log('map deleted events trigger')
	});

	const provider = new OpenStreetMapProvider();

const searchControl = new GeoSearchControl({
  provider: provider,
  style: 'bar',
  autoComplete: true, // optional: true|false  - default true
  autoCompleteDelay: 250, // optional: number      - default 250
});

// const map = new L.Map('map');
map.addControl(searchControl);


function addPopup(layer) {

  var container = `<div>
                   <label>Boundary Name</label>
                   <div><input class="form-control" type="text" placeholder="Enter Name"/></div>
                   <lable>Boundary ID</label>
                   <div><input type="text" placeholder="Enter ID" class="form-control" /></div>
                   <lable>Boundary Description</label>
                   <div><textarea rows="2 placeholder="Enter description" class="form-control"></textarea></div>
                   <div class="mt-2"><button class="btn btn-success">Save</button> <button class="btn btn-default btn-outline">Close</button></div>
                   </div>`

	var divElement = document.createElement("Div");
	divElement.id = "mainDivId";
	var contentId = document.createElement("textarea");
	contentId.id = "contentId";
	var contentName = document.createElement("textarea");
	contentName.id = "contentNameId";
	var contentDescriptio = document.createElement("textarea");
	contentDescriptio.id = "contentDescriptionId";
	var contentRegion = document.createElement("textarea");
	contentRegion.id = "contentRegionId";
	var contentContract = document.createElement("textarea");
	contentContract.id = "contentContractId";
	divElement.appendChild(contentId);
	divElement.appendChild(contentName);
	divElement.appendChild(contentDescriptio);
	divElement.appendChild(contentRegion);
	divElement.appendChild(contentContract);
	divElement.addEventListener("keyup", function () {
		console.log((document.getElementById('contentId') as HTMLInputElement).value);
		// console.log(document.querySelector('#mainDivId #contentId'))
		layer.feature.properties.Id = (document.getElementById('contentId') as HTMLInputElement).value
		layer.feature.properties.Name = (document.getElementById('contentNameId') as HTMLInputElement).value
		layer.feature.properties.Descriptio = (document.getElementById('contentDescriptionId') as HTMLInputElement).value
		layer.feature.properties.Region = (document.getElementById('contentRegionId') as HTMLInputElement).value
	  layer.feature.properties.Contract = (document.getElementById('contentContractId') as HTMLInputElement).value

	  });
	//   contentName.addEventListener("keyup", function () {
	// 	layer.feature.properties.Name = contentName.value;
	//   });
	//   contentDescriptio.addEventListener("keyup", function () {
	// 	layer.feature.properties.Descriptio = contentDescriptio.value;
	//   });
	//   contentRegion.addEventListener("keyup", function () {
	// 	layer.feature.properties.Region = contentRegion.value;
	//   });
	//   contentContract.addEventListener("keyup", function () {
	// 	layer.feature.properties.Contract = contentContract.value;
	//   });
	  layer.on("popupopen", function (e) {
		  console.log('avc',e,layer);

		(document.getElementById('contentId') as HTMLInputElement).value = layer.feature.properties.Id;
		(document.getElementById('contentNameId') as HTMLInputElement).value = layer.feature.properties.Name;
		(document.getElementById('contentDescriptionId') as HTMLInputElement).value = layer.feature.properties.Descriptio;
		(document.getElementById('contentRegionId') as HTMLInputElement).value = layer.feature.properties.Region;
		(document.getElementById('contentContractId') as HTMLInputElement).value = layer.feature.properties.Contract;
		console.log((document.getElementById('contentDescriptionId') as HTMLInputElement).value);
		// contentId.focus();
	  });
	  layer.bindPopup(divElement).openPopup();
	//   layer.bindPopup(contentName).openPopup();
	//   layer.bindPopup(contentDescriptio).openPopup();
	//   layer.bindPopup(contentRegion).openPopup();
	//   layer.bindPopup(contentContract).openPopup();
	}
	}

	uploadFiles(event){
		console.log(event.target.files)

		var file = event.target.files[0];

  if (file.name.slice(-3) != 'zip'){ //Demo only tested for .zip. All others, return.
		document.getElementById('warning').innerHTML = 'Select .zip file';
    return;
  } else {
  	document.getElementById('warning').innerHTML = ''; //clear warning message.
    this.handleZipFile(file);
  }
	}

	handleZipFile(file){
		var reader = new FileReader();
	  reader.onload = function(){
		  if (reader.readyState != 2 || reader.error){
			  return;
		  } else {
			//   this.convertToLayer(reader.result);
		  }
	  }
	  reader.readAsArrayBuffer(file);
	}

	// convertToLayer(buffer){
	// 	shp(buffer).then(function(geojson){	//More info: https://github.com/calvinmetcalf/shapefile-js
	// 	var layer = L.shapefile(geojson).addTo(map);//More info: https://github.com/calvinmetcalf/leaflet.shapefile
	// 	console.log(layer);
	//   });
	// }

}
